<template>
    <div class="mainWrapper">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Root',
};
</script>

<style lang="less" scoped>
/* purgecss start ignore */
.mainWrapper {
    width: 100%;
    background-color: #2aacea;
    ::v-deep .toolHeader {
        width: 100%;
        background-color: #2aacea;
        padding: 0em 2em 12em 2em;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: white;
        h1 {
            font-weight: 300;
            font-size: 4em;
            line-height: 1.25em;
            letter-spacing: normal;
            text-transform: none;
            max-width: 1280px;
            color: inherit;
            margin-bottom: 21px;
        }
        .button {
            background-color: white;
            color: #2aacea;
            padding: 1em 2em;
            border: none;
            text-transform: uppercase;
            font-weight: 600;
            margin: 1.5em 0 1em 0;
            text-decoration: none;
        }
        .header {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-start;
            justify-content: stretch;
            p {
                font-size: 1.5em;
                line-height: 1.75em;
                max-width: 800px;
                font-weight: 300;
                text-align: left;
                color: white;
                padding: 1em;
                box-sizing: border-box;
                a {
                    color: white;
                    text-decoration: underline;
                }
            }
            li {
                font-size: 1.35em;
                line-height: 1em;
                max-width: 800px;
                font-weight: 300;
                text-align: left;
                margin: 0.5em 0;
                box-sizing: border-box;
                margin-left: 3em;
            }
        }
        @media screen and (max-width: 1024px) {
            .header {
                p {
                    max-width: 100%;
                    margin-bottom: 0;
                }
            }
        }
        p.tagline {
            color: white;
            font-weight: 600;
        }
        div.divider {
            width: 150px;
            height: 2px;
            background-color: white;
            margin: 1em 0;
        }
    }
}

::v-deep .swell {
    transition: 100ms ease;
    &:hover {
        transform: scale(1.1);
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

// Shared styles

::v-deep main {
    background-color: #f5f8fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .main__column {
        width: 100%;
        max-width: 960px;
        padding: 2em 1em;
        box-sizing: border-box;
        position: relative;
        &--wide {
            max-width: 1140px;
        }
    }
    h1 {
        text-transform: none;
        letter-spacing: normal;
        margin-top: 1em;
        margin-bottom: 0.75em;
        text-align: center;
        font-weight: 300;
        font-size: 2.75em;
        line-height: 1.25em;
    }
}
::v-deep p {
    font-size: 1.35em;
    line-height: 1.75em;
    margin-bottom: 24px;
    text-align: center;
    color: #777777;
}

::v-deep .shadow {
    box-shadow: 0px -0.465507px 5.12058px rgba(62, 121, 160, 0.0282725),
        0px -1.56354px 17.199px rgba(62, 121, 160, 0.0417275);
}

::v-deep .shiftUp {
    margin-top: -12em;
}
/* purgecss end ignore */
</style>
